import {LoanAgreementEquipmentItemTypeEnum} from '@/models/digital-document-queue-sender-loan-agreement-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function loanAgreementEquipmentItemTypeNameFilter(type: LoanAgreementEquipmentItemTypeEnum) {
  switch (type) {
    case LoanAgreementEquipmentItemTypeEnum.FenderPresence: return i18n.t(LF.FenderPresence) as string;
    case LoanAgreementEquipmentItemTypeEnum.Flashlights: return i18n.t(LF.Flashlights) as string;
    case LoanAgreementEquipmentItemTypeEnum.FoldingLock: return i18n.t(LF.FoldingLock) as string;
    case LoanAgreementEquipmentItemTypeEnum.WaterProofPhoneBag: return i18n.t(LF.WaterProofPhoneBag) as string;
    case LoanAgreementEquipmentItemTypeEnum.PhoneHolder: return i18n.t(LF.PhoneHolder) as string;
    case LoanAgreementEquipmentItemTypeEnum.ChargedBattery: return i18n.t(LF.ChargedBattery) as string;
  }
}
